import { render, staticRenderFns } from "./EditFirstStep.vue?vue&type=template&id=552a4783&scoped=true&"
import script from "./EditFirstStep.vue?vue&type=script&lang=js&"
export * from "./EditFirstStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552a4783",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('552a4783')) {
      api.createRecord('552a4783', component.options)
    } else {
      api.reload('552a4783', component.options)
    }
    module.hot.accept("./EditFirstStep.vue?vue&type=template&id=552a4783&scoped=true&", function () {
      api.rerender('552a4783', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/uform/EditFirstStep.vue"
export default component.exports